/* eslint-disable no-shadow */

enum ContactUsTexts {
  TITLE = 'Have a question? We’re always here for you',
  WORKING_HOURS = 'Monday - Thursday 9am - 5pm EST',
}

export default ContactUsTexts;
